export default {
    bind(el) {
        el.style.backgroundColor = 'var(--Gray-20, #F3F5F8)';
        el.style.outline = 'none'; // 기본 포커스 outline 제거
        el.style.border = '0'; // 기본 border 설정
        el.style.color = 'var(--Gray-50, #A3AAB6)';
        el.addEventListener('focus', () => {   // 포커스 될때
            el.style.backgroundColor = '';            
            el.style.color = 'var(--Gray-100, #1E1E1E)';
            el.style.border = '1px solid var(--Blue-01_Primary-blue, #008DEF)'; // 포커스 시 border 색상 설정
        });
        el.addEventListener('blur', () => {  // 포커스 잃을때 
            el.style.backgroundColor = 'var(--Gray-20, #F3F5F8)';   
            el.style.border = '0'; // 포커스 해제 시 border 색상 주황색으로 설정
            el.style.color = 'var(--Gray-100, #1E1E1E)';
        });
        el.addEventListener('input', () => {  // 입력중일때 
            el.style.backgroundColor = '';
            el.style.color = 'var(--Gray-100, #1E1E1E)';
        });
    },
    unbind(el) {
        el.removeEventListener('focus', () => {  // 포커스될 때
            el.style.backgroundColor = '';
            el.style.border = '0'; // 포커스 시 border 색상 설정
            el.style.color = 'var(--Gray-50, #A3AAB6)';
        });
        el.removeEventListener('blur', () => {  // 포커스 잃을 때 
            el.style.backgroundColor = 'var(--Gray-20, #F3F5F8)';  
            el.style.border = '0'; // 포커스 해제 시 border 색상 주황색으로 설정
        });
        el.removeEventListener('input', () => {  // 입력중 일 때 
            el.style.backgroundColor = '';
            el.style.color = 'var(--Gray-50, #A3AAB6)';
        });
    },
}


// WEBPACK FOOTER //
// ./src/components/directives/focusInputStyle.js